// NBL1_Player Pages
import rules from "../../Data/Rules"
import functions from "../../Data/Functions"
import Verification from "../Steps/Verification"
import Base_Details from "../Steps/BaseDetails"
// import store from "../../veux/store"

let step1, step2, Countries, Associations, Trial, Information, Message, DOB

const PortalAgeCheck = p => v => {
    let Start = functions.FormatDate(v.DOB_Start, 'YYYY-MM-DD')
    let End = functions.FormatDate(v.DOB_End, 'YYYY-MM-DD')
    // console.log(Start, End, DOB)
    if (DOB < Start || DOB > End) {
        return 'Your Age does not qualify you for this Camp - Please select a Camp that matches your Age'
    }
    return true
}


// NBL1 Player Step Schema
const Load_NextGen_Player_Steps = () => {
    return {
        Portal: '2023 NextGen Player',
        MainColor: "#f5924c",
        Logo: require(`../../assets/BQLogo2.png`),
        Title: `<h2>2023 Next Gen Registration Form</h2>`,
        Description: `The Next Gen Program (NGP)  is aimed at finding the next generation of athlete that could one day represent Queensland. The program will also expose young athletes to a high performance environment, and provide a taste of what to expect if they progress along the High Performance pathway in the future. `,
        Model: {},
        steps: [
            // Step 1
            step1,
            // Step 2
            step2,
            // Step 3
            {
                stepno: 3,
                title: 'Rego',
                valid: true,
                information: `${Message}`,
                Schema: {
                    birthCountry: {
                        type: 'select',
                        label: 'Country of Birth',
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Country of Birth is Required')],
                        class: 'mx-1 px-1',
                        items: Countries,
                        value: '',
                        OUG: { Contact_Details: { Type: 3394, Action: "Unique" } }
                    },
                    association: {
                        type: 'select',
                        label: 'Association',
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Association is Required')],
                        class: 'mx-1 px-1',
                        items: Associations,
                        returnObject: true,
                        itemText: 'Detail',
                        value: '',
                    },
                    team: {
                        type: 'select',
                        label: 'Choose Camp',
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Camp is Required'), PortalAgeCheck()],
                        class: 'mx-1 px-1',
                        items: Trial,
                        returnObject: true,
                        itemText: 'Detail',
                        col: 12,
                        value: '',
                        Role: 1,
                        onInput: (ev, portal) => {
                            ev.obj.value.Association = ev.data.association.Code_id
                        },
                        OUG: { Contact_Roles: true, Type: "Teams" }
                    }
                },
                PreStep: (thisStep, portal) => {
                    DOB = functions.FormatDate(portal.Model.DOB, 'YYYY-MM-DD')
                },
                PostStep: (thisStep, portal) => {
                    functions.sendEmail(
                        {
                            User_Name: 'NextGen Program',
                            User_Email: 'patrick.mcinerney@basketballqld.net.au',
                            emailstosend: portal.Model.email,
                            Subject: `${portal.Model.team.Detail} Booking Confirmed`,
                            Message: `${portal.Model.team.Terms}`
                        }
                    )
                },
            },
            // Step 4
            {
                stepno: 4,
                title: 'Finish',
                valid: true,
                information: `Thank you for your submitted registration for the 2023 Next Gen.</br></br>
                If you have any queries regarding the program or your registration please contact <a href="mailto:patrick.mcinerney@basketballqld.net.au">patrick.mcinerney@basketballqld.net.au</a>`,
                Schema: {}
            }
        ]
    }
}



export default {

    LoadSchema: async (Parameters) => {
        step1 = await Verification.LoadSchema(1)
        step2 = await Base_Details.LoadSchema(2)
        Countries = await functions.GetCountries()
        Associations = await functions.GetCodeBy({ Type: "Associations", Organisation: 292 }, true);
        Trial = await functions.GetCodeBy({ Organisation: 292, Association: 1166, State_Champs: 3647, Status: 'Active' }, true);
        Information = await functions.getData('SELECT * FROM Codes_Messages WHERE Code_id = 3647', false)
        Message = Information[0].Messages
        return Load_NextGen_Player_Steps()
    },



}

